module.exports = __webpack_public_path__ + "img/faster_tran_icon128x128.5673a281.png";